import FieldEngagement from '../pages/FieldEngagement';

const fieldEngagementRoute = {
  public: [],
  auth: [
    {
      name: 'field_engagement',
      path: '/report/field-engagement',
      permissions: ['DAM', 'CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      component: FieldEngagement,
    },
  ],
};

export default fieldEngagementRoute;
